exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-enter {\n    height: 0;\n}\n\n.summary-enter.summary-enter-active {\n    height: 100%;\n    -webkit-transition: height .2s ease;\n}\n\n.summary-leave.summary-leave-active {\n    height: 0;\n    -webkit-transition: height .2s ease;\n}", ""]);

// exports
